import { create } from "zustand";
import { createUserSlice } from "./userSlice";
import { createTopologySlice } from "./topologySlice";
import { createGeneralSlice } from "./generalSlice";
import { createJSONStorage, persist } from "zustand/middleware";
import createEquipmentSlice from "./equipmentSlice";
import createReportSlice from "./reportSlice";
import createSiteSlice from "./sitesSlice";

import createAreaSlice from "./areaSlice";

import createCommandQueueSlice from "./commandQueueSlice";
import createBackupSlice from "./backupSlice";
import createAttachmentSlice from "./attachmentSlice";
import createFaqSlice from "./faqSlice";
import createMaintenanceSlice from "./maintenanceSlice";
import createNotificationSlice from "./notificationSlice";
import createUiSlice from "./uiSlice";
import liveDataSlice from "./liveDataSlice";
import createKpiSlice from "./kpiSlice";

export interface UserStore extends ReturnType<typeof createUserSlice> {}
export interface TopologyStore extends ReturnType<typeof createTopologySlice> {}
export interface GeneralStore extends ReturnType<typeof createGeneralSlice> {}
export interface ReportStore extends ReturnType<typeof createReportSlice> {}

export interface SiteStore extends ReturnType<typeof createSiteSlice> {}

export interface BackupStore extends ReturnType<typeof createBackupSlice> {}
export interface FaqStore extends ReturnType<typeof createFaqSlice> {}
export interface MaintenanceStore
  extends ReturnType<typeof createMaintenanceSlice> {}
export interface AttachmentStore
  extends ReturnType<typeof createAttachmentSlice> {}
export interface EquipmentStore
  extends ReturnType<typeof createEquipmentSlice> {}
export interface NotificationStore
  extends ReturnType<typeof createNotificationSlice> {}
export interface uiStore extends ReturnType<typeof createUiSlice> {}
export interface liveDataStore extends ReturnType<typeof liveDataSlice> {}
export interface kpiSliceStore extends ReturnType<typeof createKpiSlice> {}
export interface CommandQueueStore
  extends ReturnType<typeof createCommandQueueSlice> {}

export interface AreaSliceStore extends ReturnType<typeof createAreaSlice> {}

export const useBoundStore = create<
  UserStore &
    EquipmentStore &
    TopologyStore &
    GeneralStore &
    ReportStore &
    SiteStore &
    BackupStore &
    CommandQueueStore &
    AttachmentStore &
    FaqStore &
    NotificationStore &
    uiStore &
    liveDataStore &
    kpiSliceStore &
    AreaSliceStore &
    MaintenanceStore
>()(
  persist(
    (set, get) => ({
      ...createTopologySlice(set, get),
      ...createUserSlice(set, get),
      ...createEquipmentSlice(set, get),
      ...createReportSlice(set, get),
      ...createSiteSlice(set, get),
      ...createCommandQueueSlice(set, get),
      ...createBackupSlice(set, get),
      ...createFaqSlice(set, get),
      ...createAttachmentSlice(set, get),
      ...createMaintenanceSlice(set, get),
      ...createNotificationSlice(set, get),
      ...createUiSlice(set, get),
      ...liveDataSlice(set, get),
      ...createAreaSlice(set, get),
      ...createKpiSlice(set, get),
      ...createGeneralSlice(),
    }),
    {
      name: "local-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        executionLoader: state.executionLoader,
        reportConfigProducts:state.reportConfigProducts,
        reportConfigProductsLoader:state.reportConfigProductsLoader,
        isAdmin: state.isAdmin,
        isLoggedIn: state.isLoggedIn,
        lang: state.lang,
        userNodeId: state.userNodeId,
        legalEntityNodeId: state.legalEntityNodeId,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        isAuthUser: state.isAuthUser,
        subscribedSites: state.subscribedSites,
        subscribedAreas: state.subscribedAreas,
        subscribedEquipmentpools: state.subscribedEquipmentpools,
        getReportConfigurations: state.getReportConfigurations,
        getBackups: state.getBackups,
        maintenanceCategories: state.maintenanceCategories,
        subscribedEquipments: state.subscribedEquipments,
        _subscribedEquipments: state._subscribedEquipments,
        getAllNotifications: state.getAllNotifications,
        getKpisData: state.getKpisData,
        userInfo: state.userInfo,
        user: state.user,
        profiles: state.profiles,
        sites: state.sites,
        brandTypes: state.brandTypes,
        eventsTimeRange: state.eventsTimeRange,
        startTime: state.startTime,
        endTime: state.endTime,
        clientId: state.clientId,
        subscribedEquipmentsCalender: state.subscribedEquipmentsCalender,
        clientInfoObj: state.clientInfoObj,
        rabbitmqConfig: state.rabbitmqConfig,
      }),
    }
  )
);
